import { useState, useRef, useEffect } from 'react';
import useApi from "./useApi";

function useContract (address) {
    const [contract, setContract] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const contractApi = useApi(`contract/${address}`);
    const contractGetLoad = useRef(true);

    useEffect(() => {
        if (contractGetLoad.current) {
            contractGetLoad.current = false;
            return;
        }

        setContract(contractApi.data);
        setLoading(contractApi.loading);
        setError(contractApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractApi.loading, contractApi.error, contractApi.data]);

    const get = async () => {
        setLoading(true);
        contractApi.get();
    }

    return {
        contract,
        loading,
        error,
        get
    };
}

export default useContract;